const showOrHideElements = {
  auth: {
    signIn: {
      howDoesOptimiseWorkLink: true,
      showCompanyLogoInCard: true,
    },
    signUp: {
      howDoesOptimiseWorkLink: true,
      showCompanyLogoInCard: true,
      showMainNavOnLogin: false,
    },
  },
  onBoarding: {
    showMainNav: true,
    showCompanyLogoInCard: true,
  },
};

export default showOrHideElements;
